import './Loader.scss';

export default function Loader({ text = 'Загрузка...' }) {
    return (
        <div className="ui-loader">
            <div className="ui-loader__spinner" />
            {text && <p className="ui-loader__text">{text}</p>}
        </div>
    );
}
